function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0949 14.2576V15.4648H14.9878V16.5796H17.0949V17.7879H14.9878V19.5485H13.0111V17.7879H10.9119V16.5796H13.0111V15.4648H10.9119V14.2576H12.488L9.11975 8.4515H11.2966L13.9336 13.1968H14.072L16.7101 8.4515H18.8791L15.5109 14.2576H17.0949ZM14 3.875C8.41663 3.875 3.875 8.41775 3.875 14C3.875 19.5822 8.41663 24.125 14 24.125C19.5822 24.125 24.125 19.5822 24.125 14C24.125 8.41775 19.5822 3.875 14 3.875ZM14 25.25C7.79563 25.25 2.75 20.2032 2.75 14C2.75 7.79675 7.79563 2.75 14 2.75C20.2032 2.75 25.25 7.79675 25.25 14C25.25 20.2032 20.2032 25.25 14 25.25ZM14 0.5C6.5435 0.5 0.5 6.54463 0.5 14C0.5 21.4554 6.5435 27.5 14 27.5C21.4554 27.5 27.5 21.4554 27.5 14C27.5 6.54463 21.4554 0.5 14 0.5Z"
});

function SvgIcAreaCoinYen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaCoinYen);
export default ForwardRef;